import DocumentosAnexos from './documentosAnexos';
import { connect } from 'react-redux';
// import { bindActionCreators } from 'redux';

const mapStateToProps = (state, ownProps) => ({
  documentosAnexosReducer: state.documentosAnexosReducer,
});
// const mapDispatchToProps = dispatch =>
//   bindActionCreators({
//   }, dispatch);

export default connect(
  mapStateToProps,
  // mapDispatchToProps
)(DocumentosAnexos);
